function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-9 -9)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M14.418 22.8l-.018-5.6H12v-2.4h2.4v-1.6c0-2.16 1.337-3.2 3.264-3.2.922 0 1.715.069 1.946.1v2.256h-1.336c-1.047 0-1.25.498-1.25 1.229V14.8H20l-.8 2.4h-2.176v5.6h-2.606z"
}));

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkgLTkpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgc3Ryb2tlPSIjMDAwIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTQuNDE4IDIyLjhsLS4wMTgtNS42SDEydi0yLjRoMi40di0xLjZjMC0yLjE2IDEuMzM3LTMuMiAzLjI2NC0zLjIuOTIyIDAgMS43MTUuMDY5IDEuOTQ2LjF2Mi4yNTZoLTEuMzM2Yy0xLjA0NyAwLTEuMjUuNDk4LTEuMjUgMS4yMjlWMTQuOEgyMGwtLjggMi40aC0yLjE3NnY1LjZoLTIuNjA2eiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFacebook as ReactComponent };